<h2 mat-dialog-title data-testid="infomodal-title">{{ title }}</h2>
<mat-dialog-content class="mat-typography">
  <div [innerHTML]="message" data-testid="infomodal-text"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="border-0" color="primary" mat-dialog-close data-testid="infomodal-button">
    ENTENDI
  </button>
</mat-dialog-actions>
